<template>
    <v-container fluid fill-height grid-list-xs pa-0 :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-layout row wrap>
            <v-flex d-flex xs12 pa-0>
                <v-card class="fill-height flex-card">

                    <v-toolbar card prominent dense v-if="1==0">
                        <v-tooltip
                            bottom
                            :disabled="true"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    @click="printResult"
                                >
                                    <v-icon>mdi-printer-outline</v-icon>
                                    <span>{{ $t("print") }}</span>
                                </v-btn>
                            </template>
                            <span>{{ $t("print") }}</span>
                        </v-tooltip>
                        <v-tooltip
                            bottom
                            :disabled="true"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    @click="saveParameters"
                                >
                                    <v-icon>mdi-content-save-outline</v-icon>
                                    <span>{{ $t("save") }}</span>
                                </v-btn>
                            </template>
                            <span>{{ $t("save") }}</span>
                        </v-tooltip>
                    </v-toolbar>

                    <v-card-text class="fill-height pa-0">
                        <v-container fluid fill-height grid-list-xs pa-0>
                            <v-layout row wrap>
                                <v-flex xs12 md3 lg3 d-flex pa-0 >
                                    <v-sheet
                                        class="grey v-scrollable"
                                        :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                    >
                                        <v-expansion-panel v-model="leftPanel" readonly expand class="elevation-0" style="overflow-y: hidden;">
                                            <!-- Размеры бревна -->
                                            <v-expansion-panel-content
                                                hide-actions
                                                class="grey"
                                                :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                            >
                                                <template v-slot:header>
                                                    <div class="subheading font-weight-black">{{ $t("logDimensions") }}</div>
                                                </template>
                                                <v-card
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                    style="overflow-x: auto; overflow-y: hidden;"
                                                >
                                                    <v-card-text v-if="false" class="dense text-xs-right">{{ $t("volume") }}, {{ $t("m3") }}: <b>{{ volume }}</b></v-card-text>
                                                    <v-card-text class="dense">
                                                        <v-layout row>
                                                            <v-flex xs10>
                                                                <span class="pl-0">{{ $t("diameterTop") }}, {{ $t("mm") }}</span>
                                                                <v-slider
                                                                    v-model="dTop"
                                                                    :min="100"
                                                                    :max="600"
                                                                    class="pr-2 mt-0"
                                                                ></v-slider>
                                                            </v-flex>
                                                            <v-flex xs2 mt-2>
                                                                <v-text-field
                                                                    :value="dTop"
                                                                    @change="dTop = $event"
                                                                    class="mt-0"
                                                                    type="number"
                                                                    :rules="[rules.required, rules.dTop]"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>

                                                        <v-layout row>
                                                            <v-flex xs10>
                                                                <span class="pl-0">{{ $t("length") }}, {{ $t("m") }}</span>
                                                                <v-slider
                                                                    v-model="length"
                                                                    :min="1.0"
                                                                    :max="10.0"
                                                                    :step="0.1"
                                                                    class="pr-2 mt-0"
                                                                ></v-slider>
                                                            </v-flex>
                                                            <v-flex xs2 mt-2>
                                                                <v-text-field
                                                                    :value="length"
                                                                    @change="length = $event"
                                                                    class="mt-0"
                                                                    type="number"
                                                                    :rules="[rules.required, rules.length]"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs10>
                                                                <span class="pl-0">{{ $t("taper") }}, {{ $t("mm")}}/{{ $t("m") }}</span>
                                                                <v-slider
                                                                    v-model="taper"
                                                                    :min="0"
                                                                    :max="50"
                                                                    :disabled="useStdTable"
                                                                    class="pr-2 mt-0"
                                                                ></v-slider>
                                                            </v-flex>
                                                            <v-flex xs2 mt-2>
                                                                <v-text-field
                                                                    :value="taper"
                                                                    @change="taper = $event"
                                                                    class="mt-0"
                                                                    type="number"
                                                                    :rules="[rules.requiredNumAllowZero, rules.taper]"
                                                                    :disabled="useStdTable"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs10>
                                                                <span class="pl-0">{{ $t("curvature") }}, %</span>
                                                                <v-slider
                                                                    v-model="curvature"
                                                                    :min="0"
                                                                    :max="2"
                                                                    :step="0.05"
                                                                    :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                                                    class="pr-2 mt-0"
                                                                ></v-slider>
                                                            </v-flex>
                                                            <v-flex xs2 mt-2>
                                                                <v-text-field
                                                                    :value="curvature"
                                                                    @change="curvature = $event"
                                                                    class="mt-0 mr-0"
                                                                    type="number"
                                                                    :rules="[rules.requiredNumAllowZero, rules.curvature]"
                                                                    :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs12>
                                                                <span class="pl-0">{{ $t("curvatureCenter") }}</span>
                                                                <v-slider
                                                                    v-model="curvatureCenter"
                                                                    :min="0.05"
                                                                    :max="0.95"
                                                                    :step="0.05"
                                                                    ticks
                                                                    :tick-labels="curvatureSliderLabels"
                                                                    always-dirty
                                                                    :thumb-size="30"
                                                                    :thumb-label="true"
                                                                    class="mt-0 pr-0 pt-2"
                                                                    :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                                                ></v-slider>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs12 mt-3>
                                                                <v-layout>
                                                                    <v-flex xs10>
                                                                        <span class="pl-0">{{ $t("ellipseRatio") }}, %</span>
                                                                        <v-slider
                                                                            v-model="ellipseRatio"
                                                                            :min="0"
                                                                            :max="10"
                                                                            :step="0.1"
                                                                            class="pr-2 mt-0"
                                                                            :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                                                        ></v-slider>
                                                                    </v-flex>
                                                                    <v-flex xs2>
                                                                        <v-text-field
                                                                            :value="ellipseRatio"
                                                                            @change="ellipseRatio = $event"
                                                                            class="mt-0"
                                                                            type="number"
                                                                            :rules="[rules.requiredNumAllowZero, rules.ellipse]"
                                                                            :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs12 >
                                                                <v-switch
                                                                    :ripple="false"
                                                                    :label="$t('rotateLog90deg')"
                                                                    :input-value="rotate == 90"
                                                                    @change="rotate = rotate == 0 ? 90 : 0"
                                                                    :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                                                >
                                                                </v-switch>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-card-text>
                                                </v-card>
                                            </v-expansion-panel-content>
                                            <!-- Порода -->
                                            <v-expansion-panel-content
                                                hide-actions
                                                class="grey mt-3"
                                                :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                            >
                                                <v-card
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <v-card-text class="dense">
                                                        <v-layout row>
                                                            <v-flex xs12 d-flex>
                                                                <v-select
                                                                    v-model="speciesId"
                                                                    :items="speciesFiltered"
                                                                    item-text="name"
                                                                    item-value="id"
                                                                    :label="$t('speciesAlt')"
                                                                    v-if="speciesFiltered.length > 0"
                                                                ></v-select>
                                                                <v-alert
                                                                    type="warning"
                                                                    value="true"
                                                                    v-if="speciesLoaded && speciesFiltered.length == 0"
                                                                >{{ $t("noSpeciesSelectedWarning") }}</v-alert>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-card-text>
                                                </v-card>
                                            </v-expansion-panel-content>
                                            <!-- Тип бруса -->
                                            <v-expansion-panel-content
                                                hide-actions
                                                class="grey mt-3"
                                                :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                            >
                                                <template v-slot:header>
                                                    <div class="subheading font-weight-black">{{ $t("cantType") }}</div>
                                                </template>
                                                <v-card
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <v-card-text class="dense">
                                                        <v-layout row>
                                                            <v-flex xs12 d-flex>
                                                                <v-radio-group v-model="cantType" :mandatory="false">
                                                                    <v-radio :label="$t('cylinderCant')" value="cylinder"></v-radio>
                                                                    <v-radio :label="$t('rectangleCant')" value="rectangle"></v-radio>
                                                                </v-radio-group>
                                                            </v-flex>
                                                            <v-flex xs12 d-flex>
                                                                <v-text-field
                                                                    :label="`${$t('priceM3')}`"
                                                                    :value="cantPrice"
                                                                    @change="cantPrice = $event"
                                                                    class="mt-0"
                                                                    type="number"
                                                                    :rules="[rules.requiredNumAllowZero]"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row py-3>
                                                            <v-flex xs12 d-flex>
                                                               <v-checkbox v-model="alongLogAxis" :label="$t('alongLogAxis')"></v-checkbox>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-card-text>
                                                </v-card>
                                            </v-expansion-panel-content>


                                        </v-expansion-panel>
                                    </v-sheet>
                                </v-flex>

                                <v-flex xs12 md9 lg9 d-flex pa-0 >
                                    <v-sheet class="d-flex v-scrollable">
                                        <v-card xs12 flat>
                                            <v-card-text>
                                                <div class="model-container">
                                                    <three-d-cant-view
                                                        :log="logInfo"
                                                        :cant="cant"
                                                        :cantType="cantType"
                                                        :cutAlongLogAxis="alongLogAxis"
                                                        screenshot="false"
                                                        ref="ThreeDCantView"
                                                    />
                                                </div>
                                                <div class="pattern-container">
                                                    <pattern-vue
                                                        :pattern="pattern"
                                                        :sizeNominal="true"
                                                        :falseCore="false"
                                                        :logDTop="logInfo.dTop"
                                                        :logDBottom="logInfo.dBottom"
                                                        :ellipseRatio="logInfo.ellipseRatio"
                                                        :rotate="logInfo.rotate"
                                                        :curvatureHeight="logInfo.len * logInfo.curvature * 9.8"
                                                        :showDiameter="false"
                                                        :patternSolidBG="patternSolidBG"
                                                        :rotatePattern="rotatePattern"
                                                        sideSize="250"
                                                        ref="PatternVue"
                                                    />
                                                </div>
                                                <div class="info-table" >
                                                    <table >
                                                        <tbody>
                                                            <tr v-if="cantType == 'cylinder'">
                                                                <td>{{$t("diameterCant")}}: </td>
                                                                <td><b>{{cant.optDiam}} {{$t("mm")}}</b></td>
                                                            </tr>
                                                            <tr v-else>
                                                                <td>{{$t("dimension")}}: </td>
                                                                <td><b>{{cant.optSide}}x{{cant.optSide}} {{$t("mm")}}</b></td>
                                                            </tr>
                                                            <tr v-if="!alongLogAxis">
                                                                <td colspan="2">{{$t("cantOffset")}}: </td>
                                                                <td><b>{{(cant.shift).toFixed(2)}} {{$t("mm")}}</b></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <table >
                                                        <tbody>
                                                            <tr>
                                                                <td></td>
                                                                <td>{{$t("volume")}}, {{$t("m3")}}</td>
                                                                <td>{{$t("output")}}</td>
                                                                <td>{{$t("price")}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td align="right">{{ $t("cant") }}:</td>
                                                                <td><b>{{cant.infoTable !== undefined ? cant.infoTable.product.vol : 0}}</b></td>
                                                                <td><b>{{cant.infoTable !== undefined ? cant.infoTable.product.output : 0}}%</b></td>
                                                                <td><b>{{cant.infoTable !== undefined ? cant.infoTable.product.price : 0}}</b></td>
                                                            </tr>
                                                            <tr>
                                                                <td align="right">{{ $t("woodChips") }}:</td>
                                                                <td><b>{{cant.infoTable !== undefined ? cant.infoTable.woodChips.vol : 0}}</b></td>
                                                                <td><b>{{cant.infoTable !== undefined ? cant.infoTable.woodChips.output : 0}}%</b></td>
                                                                <td><b>{{cant.infoTable !== undefined ? cant.infoTable.woodChips.price : 0}}</b></td>
                                                            </tr>
                                                            <tr>
                                                                <td align="right">{{ $t("rawMaterials") }}:</td>
                                                                <td><b>{{cant.infoTable !== undefined ? cant.infoTable.rawMaterial.vol : 0}}</b></td>
                                                                <td></td>
                                                                <td><b>{{cant.infoTable !== undefined ? cant.infoTable.rawMaterial.price : 0}}</b></td>
                                                            </tr>
                                                            <tr>
                                                                <td></td>
                                                                <td></td>
                                                                <td>{{ $t("total") }}</td>
                                                                <td><b>{{cant.infoTable !== undefined ? cant.infoTable.total : 0}}</b></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </v-card-text>
                                        </v-card>
                                    </v-sheet>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>

            <message-box ref="MessageBox"/>

        </v-layout>
    </v-container>
</template>

<script>
    import ThreeDCantView from "@/components/patterns/ThreeDCantView";
    import MessageBox     from "@/components/dialogs/MessageBox";
    import PatternVue     from "@/components/patterns/PatternVue";

    export default {
        name: "CantProduction",

        inject: ["theme"],

        components: {
            MessageBox,
            ThreeDCantView,
            PatternVue
        },

        data () {
            return {
                visible: false,

                acl: {
                    Read:   false,
                    Create: false,
                    Modify: false,
                    Export: false,
                    Delete: false
                },

                alongLogAxis: true,

                breadCrumbs: [
                    { text: "Изготовление бруса", disabled: false }
                ],

                rules: {
                    required:  value => !!value || this.$t("requiredField"),
                    dTop:      value => (value >= 100 && value <= 600) || this.$t("incorrectValue"),
                    falseCore: value => (value >= 0 && value <= 50) || this.$t("incorrectValue"),
                    length:    value => (value >= 1 && value <= 10) || this.$t("incorrectValue"),
                    taper:     value => (value >= 0 && value <= 200) || this.$t("incorrectValue"),
                    curvature: value => (value >= 0.0 && value <= 2.0) || this.$t("incorrectValue"),
                    corelessBoardThickness: value => (value >= 0 && value <= 600) || this.$t("incorrectValue"),
                    corelessBoardPrice:     value => value >=0  || this.$t("incorrectValue"),
                    ellipse:   value => (value >= 0.0 && value <= 10.0) || this.$t("incorrectValue"),
                    requiredNumAllowZero:   value => (!!value || value == 0) || this.$t("requiredField"),
                },

                loading: {
                    pricesInfo:        false,
                    speciesInfo:       false,
                    standardTable:     false
                },

                calculate: true,
                curvature: 0.0,
                curvatureCenter: 0.5,
                curvatureSliderLabels: ["вершина", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "комель"],
                dialogWatcher: null,
                dTop: 200,
                ellipseRatio: 0,
                rotate: 0,
                length: 5.0,
                logInfo: {
                    dBottom:    0,
                    dTop:       200,
                    len:        5,
                    species:    null,
                    volume:     0,
                    curvature:  0,
                    curvCenter: 0.5,
                    taper:      0,
                    ellipseRatio: 0,
                    rotate:     0
                },
                leftPanel: [true, true, true, true, true, true],
                prices: [],
                species: [],
                speciesId: 0,
                speciesLoaded: false,
                standardTable:  [],
                taper: 0,
                cant: {},
                cantType: "cylinder",
                cantPrice:    0,
                woodChipsPrice: 0,
                rotatePattern: false,
                patternSolidBG: false,
                delayTimer: null,

                pattern:  {
                    "species": "pine",
                    "du": 42,
                    "dlimitmin": 360,
                    "dlimitmax": 500,
                    "dmin": 360,
                    "dmax": 500,
                    "order": 1,
                    "kerf": 5,
                    "vertical": 0,
                    "cylindrical": 0,
                    "items": [{
                        "order": 2,
                        "kerf": 5,
                        "vertical": 1,
                        "items": [{
                            "order": 0,
                            "kerf": 5,
                            "vertical": 1,
                            "items": [{
                                "vertical": 0,
                                "ts": 53,
                                "ws": 235,
                                "tn": 50,
                                "wn": 225,
                            }],
                        }],
                    }],
                    "v": 2
                }
            }
        },

        watch: {
            dTop: function (val) {
                if (this.delayTimer) {
                    clearTimeout(this.delayTimer);
                }
                this.delayTimer = setTimeout(() => {
                    this.logInfo.dTop = parseInt(val);
                    this.calculateVolume();
                    this.calculateCant();
                    localStorage.opt4DTop = val;
                },
                    500
                );
            },
            length: function (val) {
                if (this.delayTimer) {
                    clearTimeout(this.delayTimer);
                }
                this.delayTimer = setTimeout(() => {
                    this.logInfo.len = parseFloat(val);
                    this.calculateVolume();
                    this.calculateCant();
                    localStorage.opt4LogLength = val;
                },
                    500
                );
            },
            taper: function (val) {
                if (this.delayTimer) {
                    clearTimeout(this.delayTimer);
                }
                this.delayTimer = setTimeout(() => {
                    this.logInfo.taper = val;
                    this.calculateVolume();
                    this.calculateCant();
                    localStorage.opt4Taper = val;
                },
                    500
                );
            },
            curvature: function (val) {
                if (this.delayTimer) {
                    clearTimeout(this.delayTimer);
                }
                this.delayTimer = setTimeout(() => {
                    this.logInfo.curvature = val;
                    this.calculateCant();
                    localStorage.opt4Curvature = val;
                },
                    500
                );
            },
            curvatureCenter: function (val) {
                if (this.delayTimer) {
                    clearTimeout(this.delayTimer);
                }
                this.delayTimer = setTimeout(() => {
                    this.logInfo.curvCenter = val;
                    this.calculateCant();
                    localStorage.opt4CurvatureCenter = val;
                },
                    500
                );
            },
            ellipseRatio: function (val) {
                if (this.delayTimer) {
                    clearTimeout(this.delayTimer);
                }
                this.delayTimer = setTimeout(() => {
                    this.logInfo.ellipseRatio = val;
                    this.calculateCant();
                    localStorage.opt4EllipseRatio = val;
                },
                    500
                );
            },
            rotate: function (val) {
                this.logInfo.rotate = val;
                this.calculateCant();
                localStorage.opt4Rotate = val;
            },
            cantType:  function (val) {
                this.cant.type = val;
                localStorage.opt4CantType = val;

                this.formingCantInfoTable();

                if (val == 'cylinder') {
                    this.pattern.cylinder = 1;
                    this.pattern.items[0].items[0].items[0].ts = this.cant.optDiam;
                    this.pattern.items[0].items[0].items[0].ws = this.cant.optDiam;
                    this.pattern.items[0].items[0].items[0].tn = this.cant.optDiam;
                    this.pattern.items[0].items[0].items[0].wn = this.cant.optDiam;
                } else {
                    this.pattern.cylinder = 0;
                    this.pattern.items[0].items[0].items[0].ts = this.cant.optSide;
                    this.pattern.items[0].items[0].items[0].ws = this.cant.optSide;
                    this.pattern.items[0].items[0].items[0].tn = this.cant.optSide;
                    this.pattern.items[0].items[0].items[0].wn = this.cant.optSide;
                }
            },
            alongLogAxis:  function (val) {
                this.calculateCant();
                localStorage.opt4AlongLogAxis = val;
            },
            cantPrice: function (val) { this.formingCantInfoTable(); localStorage.opt4CantPrice = val; },
            speciesId: function (val) { this.formingCantInfoTable(); localStorage.opt4SpeciesId = val; },


        },

        mounted() {
            if (!this.$store.getters.user.loggedIn) {
                localStorage.routerPath = "/cant_opt";
                if (!this.$noRedirect.includes(this.$router.currentRoute.path)) {
                    this.$router.push("/home");
                }
            }

            this.applyLocale();

            this.dTop            = localStorage.opt4DTop            ? parseInt(localStorage.opt4DTop)              : 200;
            this.length          = localStorage.opt4LogLength       ? localStorage.opt4LogLength                   : 5.0;
            this.taper           = localStorage.opt4Taper           ? localStorage.opt4Taper                       : 0;
            this.speciesId       = localStorage.opt4SpeciesId       ? parseInt(localStorage.opt4SpeciesId)         : 0;
            this.equipmentId     = localStorage.opt4EquipmentId     ? parseInt(localStorage.opt4EquipmentId)       : 0;
            this.curvature       = localStorage.opt4Curvature       ? parseFloat(localStorage.opt4Curvature)       : 0.0;
            this.curvatureCenter = localStorage.opt4CurvatureCenter ? parseFloat(localStorage.opt4CurvatureCenter) : 0.5;
            this.ellipseRatio    = localStorage.opt4EllipseRatio    ? parseFloat(localStorage.opt4EllipseRatio)    : 0;
            this.rotate          = localStorage.opt4Rotate          ? parseFloat(localStorage.opt4Rotate)          : 0;
            this.cantPrice       = localStorage.opt4CantPrice       ? parseFloat(localStorage.opt4CantPrice)       : 0;
            this.cantType        = localStorage.opt4CantType        ? localStorage.opt4CantType                    : "cylinder";
            this.alongLogAxis    = localStorage.opt4AlongLogAxis    ? JSON.parse(localStorage.opt4AlongLogAxis)    : true;

            this.logInfo.dTop         = parseInt(this.dTop);
            this.logInfo.len          = this.length;
            this.logInfo.taper        = this.taper;
            this.logInfo.curvature    = this.curvature;
            this.logInfo.curvCenter   = this.curvatureCenter;
            this.logInfo.ellipseRatio = this.ellipseRatio;
            this.logInfo.rotate       = this.rotate;

            this.sizeNominal     = localStorage.sizeNominal  ? parseInt(localStorage.sizeNominal) : 1;

            this.loadSpecies();
            this.loadPrices();
            //await this.loadStandardTable();

            this.$root.$on("localeChanged", () => { this.applyLocale(); });

            if (this.$store.getters.settings.volCalc.method == "standardTables") {
                this.taper = 0;
            }

            this.calculateVolume();
            this.calculateCant();
        },

        computed: {
            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            },

            progressBarVisible () {
                return this.loading.pricesInfo || this.loading.speciesInfo || this.loading.standardTable;
            },

            speciesFiltered () {
                return this.species.filter(item => this.$store.getters.user.settings.selectedSpecies.includes(item.id));
            },

            useStdTable () {
                return this.$store.getters.settings.volCalc.method == "standardTables";
            },
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.breadCrumbs = [
                    { text: this.$t("cantProduction"), disabled: false }
                ];

                this.curvatureSliderLabels = [this.$t("top").toLowerCase(), "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", this.$t("bottom").toLowerCase()];
            },

            calculateVolume () {
                if (this.taper == 0) {
                    this.logInfo.taper = ((18.6 + (this.dTop/10)) / (47.6 - this.length)) * 10;
                    this.logInfo.volume = (Math.PI * this.length * Math.pow((this.dTop/10 + (this.logInfo.taper / 10 * this.length / 2)), 2)) / 40000;
                } else {
                    this.logInfo.volume = (Math.PI * this.length * Math.pow((this.dTop/10 + (this.logInfo.taper / 10 * this.length / 2)), 2)) / 40000;
                }

                this.logInfo.dBottom = this.dTop + (this.logInfo.taper * this.length);

                //this.$refs.ThreeDCantView.enableDraw = true;
            },

            calculateCant () {
                let steps = this.length*50;

                let curvatureProgib = (this.logInfo.len * this.logInfo.curvature) * 10;
                let curvStepBeforeCenter = curvatureProgib / (steps * this.logInfo.curvCenter);
                let curvStepAfterCenter = curvatureProgib / (steps * (1 - this.logInfo.curvCenter));

                let taperStep = (this.logInfo.dBottom - this.logInfo.dTop) / steps;

                let ringDiam = parseInt(this.logInfo.dTop);
                let rings = [];
                rings.push(ringDiam);

                if (this.rotate > 0) {
                    ringDiam *= (1 - this.logInfo.ellipseRatio/100);
                }

                for (let step=0; step < steps; ++step) {
                    ringDiam += taperStep;

                    if (step < steps*this.logInfo.curvCenter) {
                        ringDiam -= curvStepBeforeCenter;
                    } else {
                        ringDiam += curvStepAfterCenter;
                    }

                    rings.push(ringDiam);
                }

                let optimalDiam = Math.min( ...rings ) - 2;
                let ellipseDiam = this.logInfo.dTop * (1 - this.logInfo.ellipseRatio/100);
                if (this.curvature < 1) {
                    optimalDiam = optimalDiam > ellipseDiam ? ellipseDiam : optimalDiam;
                }

                let cantSide = optimalDiam / Math.sqrt(2);

                let shift = 0;
                if (!this.alongLogAxis && this.curvature > 0) {
                    let ratio = this.logInfo.rotate ? (1 - this.logInfo.ellipseRatio) : 1;
                    shift = ((this.logInfo.dTop*ratio) - optimalDiam)/4;
                    optimalDiam += shift*2;
                    cantSide += shift*1.8;
                }
                this.pattern.items[0].items[0].items[0].offset = shift;

                optimalDiam = parseInt(optimalDiam);
                cantSide = parseInt(cantSide);

                this.cant.shift = shift;
                //this.cant.type = this.cantType;
                this.cant.optDiam = optimalDiam;
                this.cant.optSide = cantSide;

                if (this.cantType == 'cylinder') {
                    this.pattern.cylinder = 1;
                    this.pattern.items[0].items[0].items[0].ts = optimalDiam;
                    this.pattern.items[0].items[0].items[0].ws = optimalDiam;
                    this.pattern.items[0].items[0].items[0].tn = optimalDiam;
                    this.pattern.items[0].items[0].items[0].wn = optimalDiam;
                } else {
                    this.pattern.cylinder = 0;
                    this.pattern.items[0].items[0].items[0].ts = cantSide;
                    this.pattern.items[0].items[0].items[0].ws = cantSide;
                    this.pattern.items[0].items[0].items[0].tn = cantSide;
                    this.pattern.items[0].items[0].items[0].wn = cantSide;
                }

                this.formingCantInfoTable();

                this.$refs.ThreeDCantView.enableDraw = true;
            },

            formingCantInfoTable () {
                this.cant.infoTable = {
                    product: {
                        vol:    0,
                        output: 0,
                        price:  0
                    },
                    woodChips: {
                        vol:    0,
                        output: 0,
                        price:  0
                    },
                    rawMaterial: {
                        vol:    0,
                        output: 0,
                        price:  0
                    },
                    total: 0
                };

                let cantVolume = 0
                if (this.cantType == 'cylinder') {
                    cantVolume = Math.PI * (this.cant.optDiam/2 / 1000)**2 * this.length;
                } else {
                    cantVolume = (this.cant.optSide / 1000) * (this.cant.optSide / 1000) * this.length;
                }

                let logPrice = this.prices.filter(item => item.speciesId == this.speciesId);
                let filteredPrice = logPrice.filter(item => item.dMin >= this.logInfo.dTop);

                if (logPrice.length > 0) {
                    if (filteredPrice.length == 0) {
                        logPrice = parseFloat(logPrice[logPrice.length-1].price);
                    } else {
                        logPrice = parseFloat(logPrice[logPrice.length - filteredPrice.length - 1].price);
                    }
                }

                this.cant.infoTable.product.vol = cantVolume.toFixed(3);
                this.cant.infoTable.product.output = (cantVolume / this.logInfo.volume * 100).toFixed(1);
                this.cant.infoTable.product.price = (cantVolume * this.cantPrice).toFixed(2);

                this.cant.infoTable.woodChips.vol = (this.logInfo.volume - cantVolume).toFixed(3);
                this.cant.infoTable.woodChips.output = (100 - this.cant.infoTable.product.output).toFixed(1);
                this.cant.infoTable.woodChips.price = (this.cant.infoTable.woodChips.vol * this.woodChipsPrice).toFixed(2);

                this.cant.infoTable.rawMaterial.vol = this.logInfo.volume.toFixed(3);
                this.cant.infoTable.rawMaterial.price = this.prices.length > 0
                    ? (this.logInfo.volume * logPrice).toFixed(2)
                    : 0;

                this.cant.infoTable.total = (parseFloat(this.cant.infoTable.product.price)
                                            + parseFloat(this.cant.infoTable.woodChips.price)
                                            - parseFloat(this.cant.infoTable.rawMaterial.price)).toFixed(2);
            },

            printResult () {

            },

            saveParameters () {

            },

            loadParameters () {

            },

            /**
             * Загрузка списка пород
             */
            loadSpecies () {
                this.loading.species = true;

                this.axios.get(`${this.$config.apiURL}species/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let speciesInfo = response.data.species

                            this.species = [];

                            speciesInfo.forEach((item) => {
                                this.species.push({
                                    id:   item.id,
                                    name: this.$t(item.Name)
                                });
                                if (this.speciesId == 0) {
                                    this.speciesId = item.id;
                                }
                            });

                            this.species.sort((a, b) => a.name > b.name);
                        }

                        this.loading.species = false;
                    })
                    .catch(error => {
                        this.loading.species = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData"));
                        }
                    });
            },

            loadStandardTable () {
                this.loading.standardTable = true;

                let reqURL = `${this.$config.apiURL}standards/` + this.$store.getters.settings.volCalc.standard.toUpperCase().replaceAll('_','-') + '/';

                this.axios.get(reqURL, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            //let standard = response.data.standard;
                            this.standardTable = response.data.standard;
                        }

                        this.loading.standardTable = false;
                    })
                    .catch(error => {
                        this.loading.standardTable = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadStandards") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadStandards") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadStandards"));
                        }
                    });

            },

            /**
             * Загрузка цен
             */
            loadPrices () {
                this.loading.pricesInfo = true;

                this.axios.get(`${this.$config.apiURL}prices/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let pricesInfo = response.data.prices

                            this.prices = [];

                            pricesInfo.forEach((item) => {
                                this.prices.push({
                                    id:        Number(item.id),
                                    speciesId: Number(item.SpeciesId),
                                    dMin:      item.DMin,
                                    price:     item.Price
                                });
                                if (this.speciesId == 0) {
                                    this.speciesId = item.id;
                                }
                            });
                        }

                        this.loading.pricesInfo = false;
                    })
                    .catch(error => {
                        this.loading.pricesInfo = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPricesData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            /* Отслеживание нажатия кнопки ok в диалоге */
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPricesData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPricesData"));
                        }
                    });

                this.axios.get(`${this.$config.apiURL}settings/param/raw_prices/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let rawPricesInfo = response.data.settings;
                            //this.sawdustPrice        = rawPricesInfo.saw_dust;
                            this.woodChipsPrice      = rawPricesInfo.chips;
                            //this.falseCorePricePrcnt = rawPricesInfo.false_core;
                        }
                        this.loading.pricesInfo = false;
                    })
                    .catch(error => {
                        this.loading.pricesInfo = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPricesData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            /* Отслеживание нажатия кнопки ok в диалоге */
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPricesData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPricesData"));
                        }
                    });
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },
        }
    }
</script>

<style lang="sass" scoped>
    .container.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100dvh - 48px)

    .flex-card
        display: flex
        flex-direction: column
        .v-toolbar
            flex: 0

    .model-container
        box-sizing: border-box
        border: 1px solid #aaa
        display: inline-block
        padding: 4px
        width: 100%
        margin: 0 auto
        .three-d-model
            height: calc(100dvh - 90px)

    .pattern-container
        position: absolute !important
        bottom: 25px
        right: 25px
        opacity: 50% !important
        &:hover
            opacity: 100%
            transition: all 0.5s ease-in-out

    .info-table
        margin: 10px
        padding: 10px
        position: absolute
        bottom: 20px
        background: rgba(255, 255, 255, .5)
        border: solid 1px #000
        td
            padding: 2px
            padding-left: 12px
            color: #000
</style>
